// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"3b3926b8","294":"1b976dca","704":"1b976dca","786":"fdadcdd2"}[chunkId] + ".chunk.css";
};